import { render, staticRenderFns } from "./TopNavbarLanguageSwitcher.vue?vue&type=template&id=a32e68f4&scoped=true&"
import script from "./TopNavbarLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./TopNavbarLanguageSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32e68f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a32e68f4')) {
      api.createRecord('a32e68f4', component.options)
    } else {
      api.reload('a32e68f4', component.options)
    }
    module.hot.accept("./TopNavbarLanguageSwitcher.vue?vue&type=template&id=a32e68f4&scoped=true&", function () {
      api.rerender('a32e68f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/partials/TopNavbarLanguageSwitcher.vue"
export default component.exports